import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const Svg96X96Check = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 96,
	height: 96,
	viewBox: "0 0 96 96",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12 48L36 72L84 24",
		stroke: "#0274A2",
		strokeWidth: 4,
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeDasharray: "0.01 12"
	})
});
export default Svg96X96Check;
